module.exports = __webpack_public_path__ + "static/media/one-tree.3c010eaf.png";